/**
 * E2E explanation shown on the session-review surfaces.
 *
 * Session events travel phone ↔ Worker ↔ PC daemon inside E2E envelopes; the
 * Worker only relays ciphertext. The screen never claims more than that, and
 * demo data is explicitly labelled as locally generated.
 */
import { Icon } from './Icon';

export function E2ENote({ compact = false }: { compact?: boolean }) {
  return (
    <section className="rounded-2xl border border-white/5 bg-white/[0.02] p-3.5 text-[11px] leading-relaxed text-slate-500">
      <div className="flex items-center gap-2 text-slate-300">
        <Icon name="lock" className="h-3.5 w-3.5 text-indigo-300" />
        <h2 className="text-xs font-medium">E2E 加密 · 内容直接展示</h2>
      </div>
      <ul className="mt-2 list-disc space-y-1 pl-4">
        <li>
          会话事件经 Worker 中继时使用 E2E 信封（X25519 + HKDF + AES-256-GCM，AAD 绑定类型/设备），
          Worker 只能看到密文；明文只在手机与 PC daemon 本地解密。
        </li>
        <li>内容直接展示：用户已要求移除打码/点击揭示，标题与事件文本无需二次点击即可完整查看。</li>
        <li>
          演示模式：会话数据由本机 mock daemon 生成，不经过网络；前端不读取 DSH 目录或任何本机文件。
        </li>
        <li>会话审阅严格只读：查看/刷新不会触发工具、审批或对 DSH 会话的任何写入。</li>
      </ul>
    </section>
  );
}
